import { createClient } from 'https://cdn.jsdelivr.net/npm/@supabase/supabase-js@2.45.4/+esm';

const root = document.querySelector('.sx');
if (root) boot(root);

function boot(root) {
  const URL_ = root.dataset.supabaseUrl;
  const KEY = root.dataset.supabaseKey;
  const sb = createClient(URL_, KEY, {
    auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true, storageKey: 'fight-social-auth' }
  });

  const DISCIPLINES = new Set(['bjj', 'judo', 'mma', 'muaythai', 'muay', 'boxing', 'wrestling', 'kickboxing', 'karate', 'taekwondo', 'sambo', 'grappling', 'nogi', 'gi', 'sanda', 'luta', 'catch']);

  // ---------- dom ----------
  const h = (tag, attrs, ...kids) => {
    const el = document.createElement(tag);
    if (attrs) for (const [k, v] of Object.entries(attrs)) {
      if (v === false || v == null) continue;
      if (k === 'class') el.className = v;
      else if (k.startsWith('on')) el.addEventListener(k.slice(2), v);
      else if (k === 'text') el.textContent = v;
      else if (v === true) el.setAttribute(k, '');
      else el.setAttribute(k, v);
    }
    for (const kid of kids.flat()) {
      if (kid == null || kid === false) continue;
      el.append(kid.nodeType ? kid : document.createTextNode(String(kid)));
    }
    return el;
  };
  const clear = (el) => { while (el.firstChild) el.removeChild(el.firstChild); return el; };
  const fill = (el, ...kids) => {
    clear(el);
    for (const kid of kids.flat()) { if (kid != null && kid !== false) el.append(kid); }
    return el;
  };

  const ICONS = {
    up: `<svg viewBox='0 0 24 24' aria-hidden='true'><path d='M12 5.4 20.3 18.6H3.7Z'/></svg>`,
    chat: `<svg viewBox='0 0 24 24' aria-hidden='true'><path d='M4.4 4.8h15.2c.9 0 1.6.7 1.6 1.6v8.6c0 .9-.7 1.6-1.6 1.6H10l-4.8 3.4v-3.4h-.8c-.9 0-1.6-.7-1.6-1.6V6.4c0-.9.7-1.6 1.6-1.6Z' fill='none' stroke='currentColor' stroke-width='1.7' stroke-linejoin='round'/></svg>`,
    plus: `<svg viewBox='0 0 24 24' aria-hidden='true'><path d='M12 5v14M5 12h14' fill='none' stroke='currentColor' stroke-width='2.2' stroke-linecap='round'/></svg>`,
    reply: `<svg viewBox='0 0 24 24' aria-hidden='true'><path d='M9 7 4 12l5 5M4.4 12H14a6 6 0 0 1 6 6v1' fill='none' stroke='currentColor' stroke-width='1.9' stroke-linecap='round' stroke-linejoin='round'/></svg>`
  };
  const icon = (name, cls) => {
    const s = h('span', { class: 'sx-ico' + (cls ? ' ' + cls : ''), 'aria-hidden': 'true' });
    s.innerHTML = ICONS[name];
    return s;
  };

  // ---------- time ----------
  const units = (iso) => Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  const ago = (iso) => {
    const s = units(iso);
    if (s < 60) return 'now';
    if (s < 3600) return Math.floor(s / 60) + 'm';
    if (s < 86400) return Math.floor(s / 3600) + 'h';
    if (s < 604800) return Math.floor(s / 86400) + 'd';
    return new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  };
  const agoLong = (iso) => {
    const s = units(iso);
    if (s < 90) return 'JUST NOW';
    if (s < 3600) { const n = Math.round(s / 60); return n + (n === 1 ? ' MIN AGO' : ' MINS AGO'); }
    if (s < 86400) { const n = Math.floor(s / 3600); return n + ' HR AGO'; }
    if (s < 2592000) { const n = Math.floor(s / 86400); return n + (n === 1 ? ' DAY AGO' : ' DAYS AGO'); }
    return new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric' }).toUpperCase();
  };
  const clock = (iso) => new Date(iso).toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
  const dayLabel = (iso) => new Date(iso).toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
  const heat = (votes, replies, iso) => (1 + votes + 2 * replies) / Math.pow(units(iso) / 3600 + 2, 1.2);

  // ---------- state ----------
  const S = { user: null, me: null, people: new Map(), unread: 0, view: null, timer: null, recovery: false }; const uid = () => (S.user ? S.user.id : null);

  const display = (p) => (p && (p.nickname || p.full_name || p.username)) || 'Athlete';
  const personName = (p) => (p && (p.full_name || p.nickname || p.username)) || 'Athlete';
  const handle = (p) => (p && p.username) ? '@' + p.username.toUpperCase() : 'ATHLETE';
  const avatarUrl = (p) => {
    if (!p || !p.avatar_url) return null;
    return /^https?:/.test(p.avatar_url) ? p.avatar_url : `${URL_}/storage/v1/object/public/avatars/${p.avatar_url}`;
  };
  const initial = (p) => (display(p)[0] || '?').toUpperCase();
  const avatar = (p, size = 32, ring = true) => {
    const url = avatarUrl(p);
    const rc = ring === 'light' ? ' sx-av--light' : (ring ? ' sx-av--ring' : '');
    const el = h('span', { class: 'sx-av' + rc, style: `--av:${size}px` });
    if (url) {
      const img = h('img', { src: url, alt: '', loading: 'lazy' });
      img.onerror = () => { img.remove(); el.append(h('span', { class: 'sx-av-txt', text: initial(p) })); };
      el.append(img);
    } else el.append(h('span', { class: 'sx-av-txt', text: initial(p) }));
    return el;
  };

  async function loadPeople(ids) {
    const need = [...new Set(ids.filter(Boolean))].filter((id) => !S.people.has(id));
    if (!need.length) return;
    for (let i = 0; i < need.length; i += 100) {
      const { data } = await sb.from(S.me ? 'profiles' : 'public_profiles').select('id,username,full_name,nickname,avatar_url').in('id', need.slice(i, i + 100));
      (data || []).forEach((p) => S.people.set(p.id, p));
    }
  }

  // ---------- chrome ----------
  const mount = h('div', { class: 'sx-mount' });
  clear(root).append(mount);
  const toastEl = h('div', { class: 'sx-toast', role: 'status' });
  root.append(toastEl);
  let toastT;
  const toast = (msg, bad) => {
    toastEl.textContent = msg;
    toastEl.className = 'sx-toast is-on' + (bad ? ' is-bad' : '');
    clearTimeout(toastT);
    toastT = setTimeout(() => (toastEl.className = 'sx-toast'), 3500);
  };
  const fail = (e) => (!S.me && !S.recovery) ? signInScreen() : toast((e && e.message) || 'Something went wrong. Try again.', true);
  const busy = (btn, on) => { btn.disabled = on; btn.classList.toggle('is-busy', on); };
  const withBusy = async (btn, fn) => { busy(btn, true); try { return await fn(); } catch (e) { fail(e); } finally { busy(btn, false); } };

  // ---------- routing ----------
  const go = (path) => { location.hash = '#' + path; };
  const route = () => (location.hash.replace(/^#/, '') || '/');
  window.addEventListener('hashchange', () => { if (S.me || !S.user) render(); });

  function stopTimer() { clearInterval(S.timer); S.timer = null; }
  function startTimer(ms) {
    stopTimer();
    S.timer = setInterval(() => { if (!document.hidden && S.view && S.view.refresh) S.view.refresh().catch(() => {}); refreshUnread(); }, ms);
  }
  document.addEventListener('visibilitychange', () => { if (!document.hidden && S.view && S.view.refresh) { S.view.refresh().catch(() => {}); refreshUnread(); } });

  // ---------- auth ----------
  function authShell(title, sub, ...body) {
    stopTimer(); S.view = null;
    clear(mount).append(h('div', { class: 'sx-auth' },
      h('div', { class: 'sx-auth-card' },
        h('h1', { class: 'sx-display', text: title }),
        sub ? h('p', { class: 'sx-sub', text: sub }) : null,
        ...body)));
  }
  const field = (label, input, note) => h('label', { class: 'sx-field' }, h('span', { text: label }), input, note ? h('small', { text: note }) : null);

  function signInScreen() {
    const email = h('input', { type: 'email', autocomplete: 'email', required: true, class: 'sx-input' });
    const pass = h('input', { type: 'password', autocomplete: 'current-password', required: true, class: 'sx-input' });
    const btn = h('button', { type: 'submit', class: 'sx-btn sx-btn--red sx-btn--block', text: 'Sign in' });
    const form = h('form', { class: 'sx-form', onsubmit: (e) => {
      e.preventDefault();
      withBusy(btn, async () => {
        const { error } = await sb.auth.signInWithPassword({ email: email.value.trim(), password: pass.value });
        if (error) throw error;
      });
    } }, field('Email', email), field('Password', pass), btn);
    authShell('Sign in to Social', 'Same login as the Fight app. Anything you post here shows up in the app and anything posted there shows up here.',
      form,
      h('div', { class: 'sx-links' },
        h('button', { type: 'button', class: 'sx-link', text: 'Forgot password?', onclick: forgotScreen }),
        S.user ? null : h('a', { class: 'sx-link', href: '#/', text: 'Keep browsing', onclick: (e) => { e.preventDefault(); render(); } }), h('a', { class: 'sx-link', href: '/', text: 'Get the app' })));
  }

  function forgotScreen() {
    const email = h('input', { type: 'email', autocomplete: 'email', required: true, class: 'sx-input' });
    const btn = h('button', { type: 'submit', class: 'sx-btn sx-btn--red sx-btn--block', text: 'Send reset link' });
    const form = h('form', { class: 'sx-form', onsubmit: (e) => {
      e.preventDefault();
      withBusy(btn, async () => {
        const { error } = await sb.auth.resetPasswordForEmail(email.value.trim(), { redirectTo: location.origin + location.pathname });
        if (error) throw error;
        toast('Check your email for a reset link.');
      });
    } }, field('Email', email), btn);
    authShell('Reset your password', 'We will email you a link.', form,
      h('div', { class: 'sx-links' }, h('button', { type: 'button', class: 'sx-link', text: 'Back to sign in', onclick: signInScreen })));
  }

  function recoveryScreen() {
    const p1 = h('input', { type: 'password', autocomplete: 'new-password', required: true, minlength: 8, class: 'sx-input' });
    const btn = h('button', { type: 'submit', class: 'sx-btn sx-btn--red sx-btn--block', text: 'Save password' });
    const form = h('form', { class: 'sx-form', onsubmit: (e) => {
      e.preventDefault();
      withBusy(btn, async () => {
        const { error } = await sb.auth.updateUser({ password: p1.value });
        if (error) throw error;
        S.recovery = false;
        toast('Password updated.');
        await start();
      });
    } }, field('New password', p1, 'At least 8 characters.'), btn);
    authShell('Choose a new password', null, form);
  }

  function noProfileScreen() {
    authShell('Social is for athlete accounts', 'This login has no athlete profile yet. Create one in the Fight app and come back here.',
      h('div', { class: 'sx-links' }, h('button', { type: 'button', class: 'sx-btn sx-btn--ghost', text: 'Sign out', onclick: () => sb.auth.signOut() })));
  }

  // ---------- shell ----------
  let navMsgBadge;
  function shell(active, title) {
    navMsgBadge = h('span', { class: 'sx-badge', hidden: S.unread === 0, text: S.unread > 99 ? '99+' : String(S.unread) });
    const menu = h('div', { class: 'sx-menu', hidden: true },
      h('button', { type: 'button', text: 'Blocked users', onclick: () => { menu.hidden = true; go('/blocked'); } }),
      h('button', { type: 'button', text: 'Sign out', onclick: () => sb.auth.signOut() }));
    const meBtn = h('button', { type: 'button', class: 'sx-me', 'aria-label': 'Account menu', onclick: (e) => { e.stopPropagation(); menu.hidden = !menu.hidden; } }, avatar(S.me, 30));
    root.onclick = () => { root.querySelectorAll('.sx-pop:not([hidden]),.sx-menu:not([hidden])').forEach((m) => { m.hidden = true; }); };
    const body = h('div', { class: 'sx-body' });
    clear(mount).append(h('div', { class: 'sx-frame' },
      h('header', { class: 'sx-top' },
        h('a', { class: 'sx-display sx-brand', href: '#/', text: title || 'Social' }),
        h('div', { class: 'sx-top-right' },
          h('a', { class: 'sx-iconbtn' + (active === 'msgs' ? ' is-on' : ''), href: '#/m', 'aria-label': 'Messages' }, icon('chat'), navMsgBadge),
          (S.me ? h('div', { class: 'sx-acct' }, meBtn, menu) : h('button', { type: 'button', class: 'sx-btn sx-btn--red sx-btn--sm', text: 'Sign in', onclick: () => signInScreen() })))),
      body));
    return body;
  }

  async function refreshUnread() {
    if (!S.user) return;
    try {
      const [dm, gm] = await Promise.all([
        sb.from('messages').select('id', { count: 'exact', head: true }).eq('recipient_id', uid()).eq('read', false),
        unreadGroups()
      ]);
      S.unread = (dm.count || 0) + gm;
      if (navMsgBadge) { navMsgBadge.hidden = S.unread === 0; navMsgBadge.textContent = S.unread > 99 ? '99+' : String(S.unread); }
    } catch (_) { /* ignore */ }
  }
  async function unreadGroups() {
    const { data: mem } = await sb.from('chat_group_members').select('group_id,last_read_at').eq('profile_id', uid());
    if (!mem || !mem.length) return 0;
    let n = 0;
    await Promise.all(mem.map(async (m) => {
      const { count } = await sb.from('chat_group_messages').select('id', { count: 'exact', head: true })
        .eq('group_id', m.group_id).neq('sender_id', uid()).gt('created_at', m.last_read_at);
      n += count || 0;
    }));
    return n;
  }

  // ---------- shared bits ----------
  const back = (href, label) => h('a', { class: 'sx-back', href }, '← ' + label);
  const loading = () => h('p', { class: 'sx-muted sx-pad', text: 'Loading...' });
  const empty = (t) => h('p', { class: 'sx-empty', text: t });

  const voteBtn = (count, on, onclick, style) => h('button', {
    type: 'button',
    class: 'sx-pill sx-pill--vote' + (on ? ' is-on' : '') + (style === 'bare' ? ' sx-pill--bare' : style ? ' sx-pill--sm' : ''),
    'aria-pressed': on ? 'true' : 'false',
    'aria-label': on ? 'Remove upvote' : 'Upvote',
    onclick
  }, icon('up'), h('span', { class: 'sx-pill-n', text: String(count) }));

  const countPill = (n, label, href) => h(href ? 'a' : 'span', { class: 'sx-pill sx-pill--chat', href, 'aria-label': `${n} ${label}` },
    icon('chat'), h('span', { class: 'sx-pill-n', text: String(n) }));

  const metaRow = (p, created, right) => h('div', { class: 'sx-meta' },
    avatar(p, 26),
    h('span', { class: 'sx-handle', text: handle(p) }),
    h('span', { class: 'sx-sep', text: '·' }),
    h('span', { class: 'sx-when', text: agoLong(created) }),
    right ? h('span', { class: 'sx-meta-right', text: right }) : null);

  const tagList = (tags) => (tags && tags.length)
    ? h('div', { class: 'sx-tags' }, tags.map((g) => h('span', { class: 'sx-tag' + (DISCIPLINES.has(g) ? ' is-disc' : ''), text: '#' + g })))
    : null;

  function sortTabs(cur, on) {
    return h('div', { class: 'sx-sort', role: 'tablist' }, ['HOT', 'NEW', 'TOP'].map((o) =>
      h('button', { type: 'button', role: 'tab', class: 'sx-sort-b' + (o === cur ? ' is-on' : ''), 'aria-selected': o === cur ? 'true' : 'false', text: o, onclick: () => on(o) })));
  }

  // ---------- render ----------
  function render() {
    const r = route();
    let m;
    stopTimer(); S.view = null;
    if ((m = r.match(/^\/t\/([0-9a-f-]{36})$/))) return threadView(m[1]);
    if ((m = r.match(/^\/p\/([0-9a-f-]{36})$/))) return postView(m[1]);
    if (!S.me && /^\/(new$|m($|\/)|blocked$)/.test(r)) return signInScreen(); if (r === '/new') return newThreadView();
    if (r === '/m') return inboxView();
    if (r === '/m/new') return newMessageView();
    if (r === '/m/group') return newGroupView();
    if ((m = r.match(/^\/m\/u\/([0-9a-f-]{36})$/))) return dmView(m[1]);
    if ((m = r.match(/^\/m\/g\/([0-9a-f-]{36})$/))) return groupView(m[1]);
    if (r === '/blocked') return blockedView();
    return feedView();
  }

  // ---------- communities ----------
  async function feedView() {
    const body = shell('feed');
    let sort = 'HOT', q = '', rows = [];
    const list = h('div', { class: 'sx-rows' }, loading());
    const search = h('input', { type: 'search', class: 'sx-input sx-search', placeholder: 'Search communities', 'aria-label': 'Search communities', oninput: () => { q = search.value.trim().toLowerCase(); paint(); } });
    const tabsHost = h('div');
    const paintTabs = () => clear(tabsHost).append(sortTabs(sort, (o) => { sort = o; paintTabs(); paint(); }));
    body.append(
      h('div', { class: 'sx-bar' }, tabsHost,
        h('a', { class: 'sx-btn sx-btn--red sx-btn--sm', href: '#/new' }, icon('plus'), 'New community')),
      search, list);
    paintTabs();

    function paint() {
      let r = rows.filter((t) => !q || t.name.toLowerCase().includes(q) || (t.tags || []).some((g) => g.includes(q)) || (t.description || '').toLowerCase().includes(q));
      if (sort === 'NEW') r = [...r].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      else if (sort === 'TOP') r = [...r].sort((a, b) => (b.upvotes - a.upvotes) || (b.votes - a.votes));
      clear(list);
      if (!r.length) { list.append(empty(q ? 'No communities match your search.' : 'No communities yet. Start the first one.')); return; }
      r.forEach((t) => list.append(threadRow(t)));
    }

    function threadRow(t) {
      const creator = { username: t.creator_username, full_name: t.creator_name, avatar_url: t.creator_avatar };
      const vb = voteBtn(t.upvotes, t.upvoted, async (e) => {
        e.stopPropagation();
        try {
          if (t.upvoted) { const { error } = await sb.from('thread_votes').delete().eq('thread_id', t.id).eq('user_id', uid()); if (error) throw error; t.upvoted = false; t.upvotes--; }
          else { const { error } = await sb.from('thread_votes').insert({ thread_id: t.id, user_id: uid() }); if (error) throw error; t.upvoted = true; t.upvotes++; }
          paint();
        } catch (er) { fail(er); }
      });
      const open = () => go('/t/' + t.id);
      return h('article', { class: 'sx-row sx-row--click', tabindex: '0', onclick: open, onkeydown: (e) => { if (e.key === 'Enter') open(); } },
        metaRow(creator, t.created_at),
        h('h2', { class: 'sx-title', text: t.name }),
        tagList(t.tags),
        t.description ? h('p', { class: 'sx-text', text: t.description }) : null,
        h('div', { class: 'sx-foot' }, vb, countPill(t.posts + t.replies, 'posts and replies'),
          h('span', { class: 'sx-active', text: 'ACTIVE ' + agoLong(t.last_activity) })));
    }

    async function refresh() {
      const { data, error } = await sb.rpc('list_threads');
      if (error) throw error;
      rows = data || [];
      paint();
    }
    S.view = { refresh };
    try { await refresh(); } catch (e) { clear(list).append(empty('Could not load communities.')); fail(e); }
    startTimer(15000);
  }

  function newThreadView() {
    const body = shell('feed', 'New community');
    const name = h('input', { class: 'sx-input', maxlength: 40, required: true, placeholder: 'Leg lock defense' });
    const desc = h('textarea', { class: 'sx-input', maxlength: 160, rows: 3, placeholder: 'What is this community about?' });
    const tags = h('input', { class: 'sx-input', placeholder: 'bjj, wrestling' });
    const btn = h('button', { type: 'submit', class: 'sx-btn sx-btn--red sx-btn--block', text: 'Create community' });
    const form = h('form', { class: 'sx-form sx-pad', onsubmit: (e) => {
      e.preventDefault();
      withBusy(btn, async () => {
        const n = name.value.trim();
        if (n.length < 3) throw new Error('Name must be at least 3 characters.');
        const tg = [...new Set(tags.value.toLowerCase().split(/[\s,#]+/).filter(Boolean))];
        if (tg.length > 6) throw new Error('Use at most 6 tags.');
        if (tg.some((t) => !/^[a-z0-9]{2,24}$/.test(t))) throw new Error('Tags are 2 to 24 letters or numbers.');
        const { data, error } = await sb.from('threads').insert({ name: n, description: desc.value.trim(), tags: tg, created_by: uid() }).select('id').single();
        if (error) throw error;
        go('/t/' + data.id);
      });
    } },
      field('Name', name, '3 to 40 characters.'),
      field('Description', desc, 'Optional. Up to 160 characters.'),
      field('Tags', tags, 'Optional. Up to 6 tags using letters and numbers.'),
      btn);
    body.append(back('#/', 'Community'), form);
  }

  // ---------- textarea autosize ----------
  function autoGrow(el) { el.style.height = 'auto'; el.style.height = Math.min(el.scrollHeight, 260) + 'px'; }
  function grow(el) { el.addEventListener('input', () => autoGrow(el)); requestAnimationFrame(() => autoGrow(el)); }

  // ---------- replies ----------
  function dotsMenu(items) {
    const pop = h('div', { class: 'sx-pop', hidden: true, role: 'menu' },
      items.map(([label, fn, danger]) => h('button', {
        type: 'button', role: 'menuitem', class: 'sx-pop-i' + (danger ? ' is-danger' : ''), text: label,
        onclick: (e) => { e.stopPropagation(); pop.hidden = true; fn(); }
      })));
    const btn = h('button', {
      type: 'button', class: 'sx-dots', 'aria-label': 'More options', 'aria-haspopup': 'menu',
      onclick: (e) => {
        e.stopPropagation();
        const wasShut = pop.hidden;
        root.querySelectorAll('.sx-pop:not([hidden]),.sx-menu:not([hidden])').forEach((m) => { m.hidden = true; });
        pop.hidden = !wasShut;
      }
    }, h('span', { class: 'sx-dots-d' }), h('span', { class: 'sx-dots-d' }), h('span', { class: 'sx-dots-d' }));
    return h('span', { class: 'sx-dots-wrap' }, btn, pop);
  }

  // o: { placeholder, label, initial, onInput, onCancel, submit }
  function commentBox(o) {
    const inline = !o.label;
    const ta = h('textarea', { class: 'sx-addc-in', maxlength: 1000, rows: 1, placeholder: o.placeholder || 'Add a comment' });
    if (o.initial) ta.value = o.initial;
    if (o.onInput) ta.addEventListener('input', () => o.onInput(ta.value));
    const btn = h('button', { type: 'submit', class: 'sx-addc-go', text: (o.label || 'Reply').toUpperCase() });
    const el = h('form', {
      class: 'sx-addc' + (inline ? ' sx-addc--inline' : ''),
      onsubmit: (e) => {
        e.preventDefault();
        withBusy(btn, async () => {
          const b = ta.value.trim();
          if (!b) throw new Error('Write something first.');
          await o.submit(b);
          ta.value = '';
          autoGrow(ta);
        });
      }
    },
      h('div', { class: 'sx-addc-field' }, ta),
      o.onCancel ? h('button', { type: 'button', class: 'sx-addc-x', 'aria-label': 'Cancel reply', text: '×', onclick: o.onCancel }) : null,
      btn);
    grow(ta);
    return el;
  }

  // ctx: { postId, comments, cvotes, st, ui }
  // st: { collapsed:Set, open:{kind,id}|null, draft:'', focus:false }
  // ui: { repaint(), reload() }
  function replyTree(ctx) {
    const byId = new Map(ctx.comments.map((c) => [c.id, c]));
    const kids = new Map();
    ctx.comments.forEach((c) => {
      const k = (c.parent_id && byId.has(c.parent_id)) ? c.parent_id : 'root';
      if (!kids.has(k)) kids.set(k, []);
      kids.get(k).push(c);
    });
    kids.forEach((a) => a.sort((x, y) => new Date(x.created_at) - new Date(y.created_at)));
    const countKids = (id) => (kids.get(id) || []).reduce((n, k) => n + 1 + countKids(k.id), 0);
    const st = ctx.st;
    const ui = ctx.ui;

    const build = (c) => {
      const children = kids.get(c.id) || [];
      const open = !st.collapsed.has(c.id);
      const showKids = children.length && open;
      const voted = ctx.cvotes.some((v) => v.comment_id === c.id && v.user_id === uid());
      const n = ctx.cvotes.filter((v) => v.comment_id === c.id).length;
      const mine = c.author_id === uid();
      const author = S.people.get(c.author_id);

      const node = h('div', { class: 'sx-node' + (showKids ? ' has-kids' : '') });

      const gut = h('div', { class: 'sx-gut' }, avatar(author, 30, 'light'));
      if (children.length) {
        gut.append(h('button', {
          type: 'button', class: 'sx-collapse', 'aria-expanded': open ? 'true' : 'false',
          'aria-label': open ? 'Collapse replies' : 'Expand replies',
          onclick: () => { if (open) st.collapsed.add(c.id); else st.collapsed.delete(c.id); ui.repaint(); },
          text: open ? '−' : '+'
        }));
      }

      const replyBox = (st.open && st.open.kind === 'comment' && st.open.id === c.id)
        ? commentBox({
            placeholder: 'Reply to ' + personName(author),
            initial: st.draft,
            onInput: (v) => { st.draft = v; },
            onCancel: () => { st.open = null; st.draft = ''; ui.repaint(); },
            submit: async (b) => {
              const { error } = await sb.from('post_comments').insert({ post_id: ctx.postId, author_id: uid(), body: b, parent_id: c.id });
              if (error) throw error;
              st.open = null; st.draft = '';
              st.collapsed.delete(c.id);
              await ui.reload();
            }
          })
        : null;

      const main = h('div', { class: 'sx-node-main' },
        h('div', { class: 'sx-name-row' },
          h('strong', { class: 'sx-name', text: personName(author) }),
          h('span', { class: 'sx-when', text: '· ' + ago(c.created_at) })),
        h('p', { class: 'sx-node-text', text: c.body }),
        h('div', { class: 'sx-acts' },
          voteBtn(n, voted, async () => {
            try {
              if (voted) { const { error } = await sb.from('comment_votes').delete().eq('comment_id', c.id).eq('user_id', uid()); if (error) throw error; }
              else { const { error } = await sb.from('comment_votes').insert({ comment_id: c.id, user_id: uid() }); if (error) throw error; }
              await ui.reload();
            } catch (er) { fail(er); }
          }, 'bare'),
          h('button', { type: 'button', class: 'sx-act', text: 'Reply', onclick: () => {
            if (st.open && st.open.kind === 'comment' && st.open.id === c.id) { st.open = null; st.draft = ''; }
            else { st.open = { kind: 'comment', id: c.id }; st.draft = ''; st.focus = true; }
            ui.repaint();
          } }),
          !open && children.length
            ? h('button', { type: 'button', class: 'sx-act sx-act--more', onclick: () => { st.collapsed.delete(c.id); ui.repaint(); },
                text: countKids(c.id) === 1 ? '1 reply' : countKids(c.id) + ' replies' })
            : null,
          dotsMenu(mine
            ? [['Delete', async () => {
                if (!confirm('Delete this reply? Replies under it go too.')) return;
                const { error } = await sb.from('post_comments').delete().eq('id', c.id);
                if (error) return fail(error);
                await ui.reload();
              }, true]]
            : [['Report', () => report('post', ctx.postId, c.body)],
               ['Block user', () => blockUser(c.author_id)]])),
        replyBox);

      node.append(h('div', { class: 'sx-node-row' }, gut, main));
      if (showKids) {
        const wrap = h('div', { class: 'sx-kids' });
        children.forEach((k) => wrap.append(build(k)));
        node.append(wrap);
      }
      return node;
    };

    const roots = kids.get('root') || [];
    if (!roots.length) return null;
    const wrap = h('div', { class: 'sx-kids' });
    roots.forEach((c) => wrap.append(build(c)));
    return wrap;
  }

  function focusOpenReply(scope, st) {
    if (!st.focus) return;
    st.focus = false;
    const ta = scope.querySelector('.sx-addc--inline textarea');
    if (ta) { ta.focus(); ta.selectionStart = ta.selectionEnd = ta.value.length; }
  }

  async function togglePostVote(p) {
    if (p.mine) {
      const { error } = await sb.from('post_votes').delete().eq('post_id', p.id).eq('profile_id', uid());
      if (error) throw error; p.mine = false; p.votes--;
    } else {
      const { error } = await sb.from('post_votes').insert({ post_id: p.id, profile_id: uid() });
      if (error) throw error; p.mine = true; p.votes++;
    }
  }

  // Full post block: the post, its comment box and the whole reply tree.
  function postBlock(p, comments, cvotes, st, ui, opts) {
    const author = S.people.get(p.author_id);
    const mine = p.author_id === uid();
    const o = opts || {};
    const tree = replyTree({ postId: p.id, comments, cvotes, st, ui });

    const box = commentBox({
      placeholder: 'Add a comment. Type @ to tag.',
      label: 'Comment',
      initial: (st.open && st.open.kind === 'post' && st.open.id === p.id) ? st.draft : '',
      onInput: (v) => { st.open = { kind: 'post', id: p.id }; st.draft = v; },
      submit: async (b) => {
        const { error } = await sb.from('post_comments').insert({ post_id: p.id, author_id: uid(), body: b });
        if (error) throw error;
        st.open = null; st.draft = '';
        await ui.reload();
      }
    });

    const main = h('div', { class: 'sx-node-main' },
      h('div', { class: 'sx-name-row' },
        h('strong', { class: 'sx-name', text: personName(author) }),
        h('span', { class: 'sx-when', text: '· ' + agoLong(p.created_at) })),
      p.title ? h('h2', { class: 'sx-title' + (o.head ? ' sx-title--lg' : ''), text: p.title }) : null,
      p.body ? h('p', { class: 'sx-node-text' + (o.head ? ' sx-node-text--lg' : ''), text: p.body }) : null,
      h('div', { class: 'sx-acts sx-acts--post' },
        voteBtn(p.votes, p.mine, async () => { try { await togglePostVote(p); await ui.reload(); } catch (er) { fail(er); } }),
        countPill(comments.length, 'replies', o.head ? null : '#/p/' + p.id),
        dotsMenu(mine
          ? [['Delete', async () => {
              if (!confirm('Delete this post? Replies under it go too.')) return;
              const { error } = await sb.from('posts').delete().eq('id', p.id);
              if (error) return fail(error);
              if (o.onDelete) o.onDelete(); else await ui.reload();
            }, true]]
          : [['Report', () => report('post', p.id, p.title || p.body)],
             ['Block user', () => blockUser(p.author_id)]])),
      box);

    const article = h('article', { class: 'sx-row sx-node' + (tree ? ' has-kids' : '') + (o.head ? ' sx-row--head' : '') },
      h('div', { class: 'sx-node-row' }, h('div', { class: 'sx-gut' }, avatar(author, 34, 'light')), main));
    if (tree) article.append(tree);
    return article;
  }

  // ---------- one community ----------
  async function threadView(id) {
    const body = shell('feed');
    const { data: t, error } = await sb.from('threads').select('*').eq('id', id).maybeSingle();
    if (error || !t) { body.append(back('#/', 'Community'), empty('That community could not be found.')); return; }
    await loadPeople([t.created_by]);

    let sort = 'HOT', posts = [], coms = [], cvotes = [];
    const st = { collapsed: new Set(), open: null, draft: '', focus: false };
    const list = h('div', { class: 'sx-rows' }, loading());
    const tabsHost = h('div');
    const paintTabs = () => clear(tabsHost).append(sortTabs(sort, (o) => { sort = o; paintTabs(); paint(); }));

    const title = h('input', { class: 'sx-input sx-input--title', maxlength: 140, placeholder: 'Title (optional)' });
    const text = h('textarea', { class: 'sx-input', maxlength: 2000, rows: 3, placeholder: 'Say something to this community' });
    const btn = h('button', { type: 'submit', class: 'sx-btn sx-btn--red sx-btn--sm', text: 'Post' });
    const composer = h('form', { class: 'sx-compose', onsubmit: (e) => {
      e.preventDefault();
      withBusy(btn, async () => {
        const ttl = title.value.trim(), b = text.value.trim();
        if (!ttl && !b) throw new Error('Write something first.');
        const { error: er } = await sb.from('posts').insert({ author_id: uid(), thread_id: t.id, tag: t.name, title: ttl, body: b, visibility: 'PUBLIC' });
        if (er) throw er;
        title.value = ''; text.value = ''; autoGrow(text);
        await refresh(true);
      });
    } },
      avatar(S.me, 34),
      h('div', { class: 'sx-compose-main' }, title, text, h('div', { class: 'sx-compose-foot' }, btn)));
    grow(text);

    body.append(back('#/', 'Community'),
      h('div', { class: 'sx-hero' },
        h('h2', { class: 'sx-hero-title', text: t.name }),
        tagList(t.tags),
        t.description ? h('p', { class: 'sx-text', text: t.description }) : null,
        h('div', { class: 'sx-meta sx-meta--thin' }, h('span', { class: 'sx-when', text: 'STARTED BY ' + handle(S.people.get(t.created_by)) }))),
      composer,
      h('div', { class: 'sx-bar' }, tabsHost), list);
    paintTabs();

    function paint() {
      const r = [...posts];
      if (sort === 'NEW') r.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      else if (sort === 'TOP') r.sort((a, b) => (b.votes - a.votes) || (b.replies - a.replies));
      else r.sort((a, b) => heat(b.votes, b.replies, b.created_at) - heat(a.votes, a.replies, a.created_at));
      clear(list);
      if (!r.length) { list.append(empty('Nothing here yet. Be the first.')); return; }
      r.forEach((p) => list.append(postBlock(p, coms.filter((c) => c.post_id === p.id), cvotes, st, ui)));
      focusOpenReply(list, st);
    }

    async function refresh(force) {
      const { data, error: er } = await sb.from('posts').select('id,author_id,title,body,created_at').eq('thread_id', t.id).eq('visibility', 'PUBLIC').order('created_at', { ascending: false }).limit(200);
      if (er) throw er;
      const ids = (data || []).map((p) => p.id);
      let votes = [];
      coms = []; cvotes = [];
      if (ids.length) {
        const [v, c] = await Promise.all([
          sb.from('post_votes').select('post_id,profile_id').in('post_id', ids),
          sb.from('post_comments').select('id,post_id,author_id,parent_id,body,created_at').in('post_id', ids).order('created_at', { ascending: true })
        ]);
        votes = v.data || []; coms = c.data || [];
        const cids = coms.map((x) => x.id);
        if (cids.length) cvotes = (await sb.from('comment_votes').select('comment_id,user_id').in('comment_id', cids)).data || [];
      }
      await loadPeople([...(data || []).map((p) => p.author_id), ...coms.map((c) => c.author_id)]);
      posts = (data || []).map((p) => {
        const pv = votes.filter((x) => x.post_id === p.id);
        return { ...p, votes: pv.length, mine: pv.some((x) => x.profile_id === uid()), replies: coms.filter((x) => x.post_id === p.id).length };
      });
      const a = document.activeElement;
      if (!force && a && body.contains(a) && (a.tagName === 'TEXTAREA' || a.tagName === 'INPUT')) return;
      paint();
    }
    const ui = { repaint: paint, reload: () => refresh(true) };
    S.view = { refresh };
    try { await refresh(true); } catch (e) { clear(list).append(empty('Could not load this community.')); fail(e); }
    startTimer(15000);
  }

  // ---------- a single post ----------
  async function postView(id) {
    const body = shell('feed');
    const { data: post, error } = await sb.from('posts').select('id,author_id,thread_id,title,body,created_at,visibility').eq('id', id).maybeSingle();
    if (error || !post || post.visibility !== 'PUBLIC') { body.append(back('#/', 'Community'), empty('That post could not be found.')); return; }
    let thread = null;
    if (post.thread_id) { const r = await sb.from('threads').select('id,name').eq('id', post.thread_id).maybeSingle(); thread = r.data; }

    const st = { collapsed: new Set(), open: null, draft: '', focus: false };
    const host = h('div');
    let coms = [], cvotes = [], p = null;

    body.append(back(thread ? '#/t/' + thread.id : '#/', thread ? thread.name : 'Community'), host);

    function paint() {
      clear(host).append(postBlock(p, coms, cvotes, st, ui, {
        head: true,
        onDelete: () => go(thread ? '/t/' + thread.id : '/')
      }));
      focusOpenReply(host, st);
    }

    async function refresh(force) {
      const [v, c] = await Promise.all([
        sb.from('post_votes').select('post_id,profile_id').eq('post_id', post.id),
        sb.from('post_comments').select('id,post_id,author_id,parent_id,body,created_at').eq('post_id', post.id).order('created_at', { ascending: true })
      ]);
      if (c.error) throw c.error;
      const votes = v.data || [];
      coms = c.data || [];
      const cids = coms.map((x) => x.id);
      cvotes = cids.length ? ((await sb.from('comment_votes').select('comment_id,user_id').in('comment_id', cids)).data || []) : [];
      await loadPeople([post.author_id, ...coms.map((x) => x.author_id)]);
      p = { ...post, votes: votes.length, mine: votes.some((x) => x.profile_id === uid()), replies: coms.length };
      const a = document.activeElement;
      if (!force && a && body.contains(a) && (a.tagName === 'TEXTAREA' || a.tagName === 'INPUT')) return;
      paint();
    }
    const ui = { repaint: paint, reload: () => refresh(true) };
    S.view = { refresh };
    try { await refresh(true); } catch (e) { clear(host).append(empty('Could not load replies.')); fail(e); }
    startTimer(15000);
  }

  // ---------- moderation ----------
  async function report(type, targetId, context) {
    if (!confirm('Report this to the Fight team?')) return;
    const { error } = await sb.from('reports').insert({ reporter_id: uid(), target_type: type, target_id: String(targetId), context: String(context || '').slice(0, 300) });
    if (error) return fail(error);
    toast('Thanks. We will take a look.');
  }
  async function blockUser(id) {
    if (!confirm('Block this user? You will stop seeing their posts, replies and messages.')) return;
    const { error } = await sb.from('blocked_users').insert({ blocker_id: uid(), blocked_id: id });
    if (error && error.code !== '23505') return fail(error);
    toast('User blocked.');
    go('/');
  }

  async function blockedView() {
    const body = shell('feed', 'Blocked');
    const list = h('div', { class: 'sx-rows' }, loading());
    body.append(back('#/', 'Community'), list);
    const { data } = await sb.from('blocked_users').select('blocked_id,created_at').eq('blocker_id', uid());
    await loadPeople((data || []).map((b) => b.blocked_id));
    clear(list);
    if (!data || !data.length) { list.append(empty('You have not blocked anyone.')); return; }
    data.forEach((b) => {
      const p = S.people.get(b.blocked_id);
      list.append(h('div', { class: 'sx-row sx-row--flat' },
        h('span', { class: 'sx-person' }, avatar(p, 30, false), h('span', { class: 'sx-handle', text: handle(p) })),
        h('button', { type: 'button', class: 'sx-btn sx-btn--ghost sx-btn--sm', text: 'Unblock', onclick: async () => {
          const { error } = await sb.from('blocked_users').delete().eq('blocker_id', uid()).eq('blocked_id', b.blocked_id);
          if (error) return fail(error);
          blockedView();
        } })));
    });
  }

  // ---------- messages ----------
  async function loadInbox() {
    const me = uid();
    const [dms, mem] = await Promise.all([
      sb.from('messages').select('id,sender_id,recipient_id,body,read,created_at').or(`sender_id.eq.${me},recipient_id.eq.${me}`).order('created_at', { ascending: false }).limit(600),
      sb.from('chat_group_members').select('group_id,last_read_at').eq('profile_id', me)
    ]);
    if (dms.error) throw dms.error;
    const convos = new Map();
    (dms.data || []).forEach((m) => {
      const other = m.sender_id === me ? m.recipient_id : m.sender_id;
      let c = convos.get(other);
      if (!c) { c = { kind: 'dm', id: other, last: m, unread: 0 }; convos.set(other, c); }
      if (m.recipient_id === me && !m.read) c.unread++;
    });
    const items = [...convos.values()];
    const gids = (mem.data || []).map((m) => m.group_id);
    if (gids.length) {
      const [gs, gm] = await Promise.all([
        sb.from('chat_groups').select('id,name,photo_url,created_at').in('id', gids),
        sb.from('chat_group_messages').select('id,group_id,sender_id,body,created_at').in('group_id', gids).order('created_at', { ascending: false }).limit(600)
      ]);
      (gs.data || []).forEach((g) => {
        const msgs = (gm.data || []).filter((m) => m.group_id === g.id);
        const lr = (mem.data.find((m) => m.group_id === g.id) || {}).last_read_at;
        items.push({ kind: 'group', id: g.id, group: g, last: msgs[0] || null, unread: msgs.filter((m) => m.sender_id !== me && (!lr || m.created_at > lr)).length });
      });
      await loadPeople((gm.data || []).map((m) => m.sender_id));
    }
    await loadPeople(items.filter((i) => i.kind === 'dm').map((i) => i.id));
    items.sort((a, b) => new Date((b.last || b.group).created_at) - new Date((a.last || a.group).created_at));
    return items;
  }

  async function inboxView() {
    const body = shell('msgs', 'Messages');
    const list = h('div', { class: 'sx-rows' }, loading());
    body.append(
      back('#/', 'Community'),
      h('div', { class: 'sx-bar' },
        h('span', { class: 'sx-muted', text: 'Direct messages and group chats from the app.' }),
        h('span', { class: 'sx-btns' },
          h('a', { class: 'sx-btn sx-btn--ghost sx-btn--sm', href: '#/m/group', text: 'New group' }),
          h('a', { class: 'sx-btn sx-btn--red sx-btn--sm', href: '#/m/new' }, icon('plus'), 'New message'))),
      list);
    async function refresh() {
      const items = await loadInbox();
      S.unread = items.reduce((n, i) => n + i.unread, 0);
      if (navMsgBadge) { navMsgBadge.hidden = S.unread === 0; navMsgBadge.textContent = String(S.unread); }
      clear(list);
      if (!items.length) { list.append(empty('No conversations yet. Start one with New message.')); return; }
      items.forEach((i) => {
        const isDm = i.kind === 'dm';
        const p = isDm ? S.people.get(i.id) : null;
        const who = i.last && i.last.sender_id === uid() ? 'You: ' : (!isDm && i.last ? display(S.people.get(i.last.sender_id)) + ': ' : '');
        list.append(h('a', { class: 'sx-row sx-convo' + (i.unread ? ' is-unread' : ''), href: isDm ? '#/m/u/' + i.id : '#/m/g/' + i.id },
          isDm ? avatar(p, 44, false) : h('span', { class: 'sx-av sx-av--group', style: '--av:44px' }, h('span', { class: 'sx-av-txt', text: (i.group.name[0] || 'G').toUpperCase() })),
          h('span', { class: 'sx-convo-main' },
            h('span', { class: 'sx-convo-top' }, h('strong', { text: isDm ? display(p) : i.group.name }), h('span', { class: 'sx-when', text: ago((i.last || i.group).created_at) })),
            h('span', { class: 'sx-convo-last', text: i.last ? who + i.last.body : 'No messages yet' })),
          i.unread ? h('span', { class: 'sx-badge', text: String(i.unread) }) : null));
      });
    }
    S.view = { refresh };
    try { await refresh(); } catch (e) { clear(list).append(empty('Could not load messages.')); fail(e); }
    startTimer(8000);
  }

  function userPicker(onPick, selected) {
    const input = h('input', { type: 'search', class: 'sx-input', placeholder: 'Search by username or name', 'aria-label': 'Search people' });
    const res = h('div', { class: 'sx-rows' });
    let t;
    input.addEventListener('input', () => {
      clearTimeout(t);
      t = setTimeout(async () => {
        const q = input.value.trim().replace(/[%,()]/g, '');
        clear(res);
        if (q.length < 2) return;
        const { data } = await sb.from('profiles').select('id,username,full_name,nickname,avatar_url')
          .or(`username.ilike.%${q}%,full_name.ilike.%${q}%,nickname.ilike.%${q}%`).neq('id', uid()).limit(15);
        (data || []).forEach((p) => S.people.set(p.id, p));
        if (!data || !data.length) { res.append(empty('No one found.')); return; }
        data.filter((p) => !(selected && selected.has(p.id))).forEach((p) =>
          res.append(h('button', { type: 'button', class: 'sx-row sx-row--flat sx-pick', onclick: () => onPick(p) },
            h('span', { class: 'sx-person' }, avatar(p, 32, false), h('span', {}, h('strong', { text: display(p) }), h('span', { class: 'sx-handle sx-handle--sub', text: handle(p) }))))));
      }, 250);
    });
    return h('div', { class: 'sx-pad' }, input, res);
  }

  function newMessageView() {
    const body = shell('msgs', 'New message');
    body.append(back('#/m', 'Messages'), userPicker((p) => go('/m/u/' + p.id)));
  }

  function newGroupView() {
    const body = shell('msgs', 'New group');
    const picked = new Map();
    const name = h('input', { class: 'sx-input', maxlength: 60, placeholder: 'Group name' });
    const chips = h('div', { class: 'sx-tags' });
    const btn = h('button', { type: 'button', class: 'sx-btn sx-btn--red sx-btn--block', text: 'Create group', onclick: () => withBusy(btn, async () => {
      const n = name.value.trim();
      if (!n) throw new Error('Name your group.');
      if (!picked.size) throw new Error('Add at least one person.');
      const { data: g, error } = await sb.from('chat_groups').insert({ name: n, created_by: uid() }).select('id').single();
      if (error) throw error;
      const rows = [uid(), ...picked.keys()].map((pid) => ({ group_id: g.id, profile_id: pid }));
      const { error: er } = await sb.from('chat_group_members').insert(rows);
      if (er) throw er;
      go('/m/g/' + g.id);
    }) });
    const paintChips = () => { clear(chips); picked.forEach((p) => chips.append(h('button', { type: 'button', class: 'sx-tag sx-tag--x', title: 'Remove', onclick: () => { picked.delete(p.id); paintChips(); }, text: display(p) + ' ×' }))); };
    body.append(back('#/m', 'Messages'),
      h('div', { class: 'sx-form sx-pad' }, field('Group name', name), chips),
      userPicker((p) => { picked.set(p.id, p); paintChips(); }, picked),
      h('div', { class: 'sx-pad' }, btn));
  }

  function chatShell(titleNode, headerRight) {
    const body = shell('msgs');
    const log = h('div', { class: 'sx-log', 'aria-live': 'polite' }, loading());
    const input = h('textarea', { class: 'sx-input', rows: 1, maxlength: 2000, placeholder: 'Message', 'aria-label': 'Message' });
    const btn = h('button', { type: 'submit', class: 'sx-btn sx-btn--red sx-btn--sm', text: 'Send' });
    const form = h('form', { class: 'sx-send' }, input, btn);
    grow(input);
    input.addEventListener('keydown', (e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); form.requestSubmit(); } });
    body.append(h('div', { class: 'sx-chat-head' }, back('#/m', 'Messages'), titleNode, headerRight || null), log, form);
    return { log, input, btn, form };
  }
  function paintLog(log, msgs, isGroup) {
    const atBottom = log.scrollHeight - log.scrollTop - log.clientHeight < 80;
    clear(log);
    if (!msgs.length) log.append(empty('No messages yet. Say hello.'));
    let day = '';
    msgs.forEach((m) => {
      const d = dayLabel(m.created_at);
      if (d !== day) { day = d; log.append(h('div', { class: 'sx-day', text: d })); }
      const mine = m.sender_id === uid();
      log.append(h('div', { class: 'sx-msg' + (mine ? ' is-mine' : '') },
        isGroup && !mine ? h('div', { class: 'sx-msg-who', text: display(S.people.get(m.sender_id)) }) : null,
        h('div', { class: 'sx-bubble', text: m.body }),
        h('div', { class: 'sx-msg-time', text: clock(m.created_at) })));
    });
    if (atBottom || !log.dataset.init) { log.scrollTop = log.scrollHeight; log.dataset.init = '1'; }
  }

  async function dmView(otherId) {
    const me = uid();
    await loadPeople([otherId]);
    const other = S.people.get(otherId);
    if (!other) { const b = shell('msgs'); b.append(back('#/m', 'Messages'), empty('That person could not be found.')); return; }
    const title = h('div', { class: 'sx-chat-title' }, avatar(other, 34, false),
      h('span', {}, h('strong', { text: display(other) }), h('span', { class: 'sx-handle sx-handle--sub', text: handle(other) })));
    const more = h('div', { class: 'sx-btns' },
      h('button', { type: 'button', class: 'sx-link', text: 'Report', onclick: () => report('user', otherId, other.username) }),
      h('button', { type: 'button', class: 'sx-link', text: 'Block', onclick: async () => {
        if (!confirm('Block this user? You will stop receiving their messages.')) return;
        const { error } = await sb.from('blocked_users').insert({ blocker_id: me, blocked_id: otherId });
        if (error && error.code !== '23505') return fail(error);
        go('/m');
      } }));
    const c = chatShell(title, more);
    async function refresh() {
      const { data, error } = await sb.from('messages').select('id,sender_id,recipient_id,body,read,created_at')
        .or(`and(sender_id.eq.${me},recipient_id.eq.${otherId}),and(sender_id.eq.${otherId},recipient_id.eq.${me})`)
        .order('created_at', { ascending: false }).limit(300);
      if (error) throw error;
      const msgs = (data || []).reverse();
      paintLog(c.log, msgs, false);
      if (msgs.some((m) => m.recipient_id === me && !m.read)) {
        await sb.from('messages').update({ read: true }).eq('sender_id', otherId).eq('recipient_id', me).eq('read', false);
        refreshUnread();
      }
    }
    c.form.addEventListener('submit', (e) => {
      e.preventDefault();
      const b = c.input.value.trim();
      if (!b) return;
      withBusy(c.btn, async () => {
        const { error } = await sb.from('messages').insert({ sender_id: me, recipient_id: otherId, body: b });
        if (error) throw error;
        c.input.value = ''; autoGrow(c.input);
        await refresh();
      });
    });
    S.view = { refresh };
    try { await refresh(); } catch (e) { fail(e); }
    startTimer(5000);
  }

  async function groupView(gid) {
    const me = uid();
    const { data: g } = await sb.from('chat_groups').select('id,name,created_by').eq('id', gid).maybeSingle();
    if (!g) { const b = shell('msgs'); b.append(back('#/m', 'Messages'), empty('That group could not be found.')); return; }
    const { data: mem } = await sb.from('chat_group_members').select('profile_id').eq('group_id', gid);
    await loadPeople((mem || []).map((m) => m.profile_id));
    const title = h('div', { class: 'sx-chat-title' },
      h('span', { class: 'sx-av sx-av--group', style: '--av:34px' }, h('span', { class: 'sx-av-txt', text: (g.name[0] || 'G').toUpperCase() })),
      h('span', {}, h('strong', { text: g.name }), h('span', { class: 'sx-handle sx-handle--sub', text: `${(mem || []).length} MEMBERS` })));
    const more = h('button', { type: 'button', class: 'sx-link sx-danger', text: 'Leave group', onclick: async () => {
      if (!confirm('Leave this group?')) return;
      const { error } = await sb.from('chat_group_members').delete().eq('group_id', gid).eq('profile_id', me);
      if (error) return fail(error);
      go('/m');
    } });
    const c = chatShell(title, more);
    async function refresh() {
      const { data, error } = await sb.from('chat_group_messages').select('id,sender_id,body,created_at').eq('group_id', gid).order('created_at', { ascending: false }).limit(300);
      if (error) throw error;
      const msgs = (data || []).reverse();
      await loadPeople(msgs.map((m) => m.sender_id));
      paintLog(c.log, msgs, true);
      await sb.from('chat_group_members').update({ last_read_at: new Date().toISOString() }).eq('group_id', gid).eq('profile_id', me);
      refreshUnread();
    }
    c.form.addEventListener('submit', (e) => {
      e.preventDefault();
      const b = c.input.value.trim();
      if (!b) return;
      withBusy(c.btn, async () => {
        const { error } = await sb.from('chat_group_messages').insert({ group_id: gid, sender_id: me, body: b });
        if (error) throw error;
        c.input.value = ''; autoGrow(c.input);
        await refresh();
      });
    });
    S.view = { refresh };
    try { await refresh(); } catch (e) { fail(e); }
    startTimer(5000);
  }

  // ---------- boot ----------
  async function start() {
    const { data } = await sb.auth.getSession();
    S.user = data.session ? data.session.user : null;
    if (S.recovery) return recoveryScreen();
    if (!S.user) { S.me = null; return render(); }
    const { data: me } = await sb.from('profiles').select('id,username,full_name,nickname,avatar_url').eq('id', uid()).maybeSingle();
    if (!me) return noProfileScreen();
    S.me = me; S.people.set(me.id, me);
    await refreshUnread();
    render();
  }

  sb.auth.onAuthStateChange((event, session) => {
    if (event === 'PASSWORD_RECOVERY') { S.recovery = true; setTimeout(start, 0); }
    else if (event === 'SIGNED_OUT') { S.user = null; S.me = null; setTimeout(start, 0); }
    else if (event === 'SIGNED_IN' && (!S.user || !session || session.user.id !== uid())) { setTimeout(start, 0); }
  });
  start();
}
